import { Injectable } from '@angular/core';
// import firebase from 'firebase/app';
import firebase from 'firebase/app';
import 'firebase/auth';
import 'firebase/storage';
import 'firebase/database';
import 'firebase/firestore';
import 'firebase/messaging';
import 'firebase/functions';

import { Playlist } from '../data/Playlist';
import { Song } from '../data/Song';
import { Album } from '../data/Album';
import { Artist } from '../data/Artist';
import { SearchItem } from '../data/SearchItem';
import { SearchItemType } from '../data/SearchItemType';
import { PlaylistGroup } from '../data/PlaylistGroup';
import { Genre } from '../data/Genre';
import { Observable } from 'rxjs';
import { AngularFireAuth } from '@angular/fire/auth';
import { AngularFirestore, QueryDocumentSnapshot } from "@angular/fire/firestore";
// import { AudioService } from './AudioService';
import { Quotes } from '../data/Quotes';
import { CTA } from 'src/data/cta';

@Injectable()
export class FirestoreService {
  uid: string = "";
  constructor(public afAuth: AngularFireAuth,
    private afStore: AngularFirestore,
    // private audioService: AudioService
  ) {
    this.uid = localStorage.getItem('uid');

    afAuth.authState.subscribe(async (user: any) => {
      if (user) {
        this.uid = await user.uid;
        localStorage.setItem('uid', user.uid);
      } else {
        this.uid = null;
        localStorage.setItem('uid', null);

      }

    });
  }

  getUserName() {
    console.log('get user chala', this.uid)

    return new Observable((observer) => {
      // const db = this.afStore
      const db = firebase.firestore();
      if (this.uid)
        db.collection('users')
          .doc(this.uid)
          .get()
          .then((userData) => {
            console.log({ userData });
            var _user = userData.data();
            observer.next(_user.name);
            // console.log('user data', cd);
          })
          .catch((e) => console.log('err', e));
    });


  }
  async addUser(name?: string, email?: string) {
    // var user: firebase.User;
    var user = await this.afAuth.currentUser;
    // if (user) console.log('user is login ', user);
    // console.log('user', user, name, email);
    const promise = new Promise((resolve, reject) => {
      const db = firebase.firestore();

      db.collection('users')
        .doc(user.uid)
        .set(
          {
            name: user.displayName,
            email: user.email,
          },
          { merge: true }
        )
        .then(function () {
          resolve(true);
        })
        .catch(function (error) {
          reject(error);
        });
    });

    return promise;
  }
  // addUser(user: firebase.User) {
  //   // var user: firebase.User;
  //   // console.log('add user calls af 2', user, name);
  //   var name = localStorage.getItem('name');
  //   const promise = new Promise((resolve, reject) => {
  //     const db = firebase.firestore();

  //     db.collection("users")
  //       .doc(user.uid)
  //       .set(
  //         {
  //           name: name
  //         },
  //         { merge: true }
  //       )
  //       .then(function () {
  //         // localStorage.removeItem('name');
  //         resolve(true);
  //       })
  //       .catch(function (error) {
  //         reject(error);
  //       });
  //   });

  //   return promise;
  // }

  getRecentSearches(userId: string) {
    const promise = new Promise((resolve, reject) => {
      const db = firebase.firestore();

      // only get the latest 10 recent searches
      db.collection('users')
        .doc(userId)
        .collection('recentSearches')
        .orderBy('addedAt', 'desc')
        .limit(10)
        .get()
        .then((recentSearchesSnapshot) => {
          const recentSearches = [];

          recentSearchesSnapshot.forEach((doc) => {
            var itemType = doc.data().itemType;

            if (itemType == SearchItemType.Song) {
              const song = new Song();

              song.songId = doc.id;
              song.name = doc.data().name;
              song.artistId = doc.data().artistId;
              song.artistName = doc.data().artistName;
              song.albumId = doc.data().albumId;
              song.albumName = doc.data().albumName;
              song.albumPicture = doc.data().albumPicture;
              song.songUrl = doc.data().songUrl;

              recentSearches.push(song);
            } else if (itemType == SearchItemType.Artist) {
              const artist = new Artist();

              artist.artistId = doc.id;
              artist.name = doc.data().name;
              artist.picture = doc.data().picture;

              recentSearches.push(artist);
            } else if (itemType == SearchItemType.Album) {
              const album = new Album();

              album.albumId = doc.id;
              album.name = doc.data().name;
              album.picture = doc.data().picture;
              album.artistId = doc.data().artistId;
              album.artistName = doc.data().artistName;

              recentSearches.push(album);
            }
          });

          resolve({ recentSearches: recentSearches });
        })
        .catch(function (error) {
          reject(error);
        });
    });

    return promise;
  }

  addSongToRecentSearches(userId: string, song: Song) {
    const promise = new Promise((resolve, reject) => {
      const db = firebase.firestore();

      db.collection('users')
        .doc(userId)
        .collection('recentSearches')
        .doc(song.songId)
        .set({
          itemType: SearchItemType.Song,
          name: song.name,
          artistId: song.artistId,
          artistName: song.artistName,
          albumId: song.albumId,
          albumName: song.albumName,
          albumPicture: song.albumPicture,
          songUrl: song.songUrl,
          addedAt: firebase.firestore.FieldValue.serverTimestamp(),
        })
        .then(function () {
          resolve(true);
        })
        .catch(function (error) {
          reject(error);
        });
    });

    return promise;
  }

  addArtistToRecentSearches(userId: string, artist: Artist) {
    const promise = new Promise((resolve, reject) => {
      const db = firebase.firestore();

      db.collection('users')
        .doc(userId)
        .collection('recentSearches')
        .doc(artist.artistId)
        .set({
          itemType: SearchItemType.Artist,
          name: artist.name,
          picture: artist.picture,
          addedAt: firebase.firestore.FieldValue.serverTimestamp(),
        })
        .then(function () {
          resolve(true);
        })
        .catch(function (error) {
          reject(error);
        });
    });

    return promise;
  }

  addAlbumToRecentSearches(userId: string, album: Album) {
    const promise = new Promise((resolve, reject) => {
      const db = firebase.firestore();

      db.collection('users')
        .doc(userId)
        .collection('recentSearches')
        .doc(album.albumId)
        .set({
          itemType: SearchItemType.Album,
          name: album.name,
          picture: album.picture,
          artistId: album.artistId,
          artistName: album.artistName,
          addedAt: firebase.firestore.FieldValue.serverTimestamp(),
        })
        .then(function () {
          resolve(true);
        })
        .catch(function (error) {
          reject(error);
        });
    });

    return promise;
  }

  clearRecentSearch(userId: string, searchItem: SearchItem) {
    const promise = new Promise((resolve, reject) => {
      const db = firebase.firestore();

      db.collection('users')
        .doc(userId)
        .collection('recentSearches')
        .doc(searchItem.id)
        .delete()
        .then(() => {
          resolve(true);
        })
        .catch(function (error) {
          reject(error);
        });
    });

    return promise;
  }

  clearAllRecentSearches(userId: string) {
    const promise = new Promise((resolve, reject) => {
      const db = firebase.firestore();

      db.collection('users')
        .doc(userId)
        .collection('recentSearches')
        .get()
        .then((recentSearchesSnapshot) => {
          recentSearchesSnapshot.forEach((doc) => {
            db.collection('users')
              .doc(userId)
              .collection('recentSearches')
              .doc(doc.id)
              .delete();
          });

          resolve(true);
        })
        .catch(function (error) {
          reject(error);
        });
    });

    return promise;
  }

  getRecentlyPlayed(userId: string) {
    const promise = new Promise((resolve, reject) => {
      const db = firebase.firestore();

      // only get the latest 10 recent searches
      db.collection('users')
        .doc(userId)
        .collection('recentlyPlayed')
        .orderBy('addedAt', 'desc')
        .limit(10)
        .get()
        .then((recentlyPlayedSnapshot) => {
          const recentlyPlayed = [];

          recentlyPlayedSnapshot.forEach((doc) => {
            const song = new Song();

            song.songId = doc.id;
            song.name = doc.data().name;
            song.artistId = doc.data().artistId;
            song.artistName = doc.data().artistName;
            song.albumId = doc.data().albumId;
            song.albumName = doc.data().albumName;
            song.albumPicture = doc.data().albumPicture;
            song.songUrl = doc.data().songUrl;

            recentlyPlayed.push(song);
          });

          resolve({ recentlyPlayed: recentlyPlayed });
        })
        .catch(function (error) {
          reject(error);
        });
    });

    return promise;
  }

  addSongToRecentlyPlayed(userId: string, song: Song) {
    const promise = new Promise((resolve, reject) => {
      const db = firebase.firestore();

      db.collection('users')
        .doc(userId)
        .collection('recentlyPlayed')
        .doc(song.songId)
        .set({
          name: song.name,
          artistId: song.artistId,
          artistName: song.artistName,
          albumId: song.albumId,
          albumName: song.albumName,
          albumPicture: song.albumPicture,
          songUrl: song.songUrl,
          addedAt: firebase.firestore.FieldValue.serverTimestamp(),
        })
        .then(function () {
          resolve(true);
        })
        .catch(function (error) {
          console.error(error);
          reject(error);
        });
    });

    return promise;
  }

  getPlaylists() {
    const promise = new Promise((resolve, reject) => {
      const db = firebase.firestore();

      db.collection('playlists')
        .get()
        .then((playlistsSnapshot) => {
          const playlists = [];

          playlistsSnapshot.forEach((doc) => {
            const playlist = new Playlist();

            playlist.playlistId = doc.id;
            playlist.name = doc.data().name;
            playlist.picture = doc.data().picture;

            playlists.push(playlist);
          });

          resolve({ playlists: playlists });
        });
    });

    return promise;
  }

  getPlayListLength(id) {
    const promise = new Promise((res) => {
      const db = firebase.firestore();

      db.collection('playlists')
        .doc(id)
        .collection('songs')
        .get()
        .then((playlistSongsSnapshot) => {
          // const playlistSongs = [];
          var size = playlistSongsSnapshot.size;
          // playlistSongsSnapshot.forEach(doc => {
          //   const song = new Song();

          //   song.playlistSongId = doc.id;

          //   song.songId = doc.data().songId;
          //   song.name = doc.data().name;
          //   song.artistId = doc.data().artistId;
          //   song.artistName = doc.data().artistName;
          //   song.albumId = doc.data().albumId;
          //   song.albumName = doc.data().albumName;
          //   song.albumPicture = doc.data().albumPicture;
          //   song.songUrl = doc.data().songUrl;

          //   playlistSongs.push(song);
          // });

          res(size);
        });
    });
    return promise;
  }

  getPlaylistSongs(playlist: Playlist) {
    const promise = new Promise((resolve, reject) => {
      const db = firebase.firestore();

      db.collection('playlists')
        .doc(playlist.playlistId)
        .collection('songs')
        .get()
        .then((playlistSongsSnapshot) => {
          const playlistSongs = [];

          playlistSongsSnapshot.forEach((doc) => {
            const song = new Song();

            song.playlistSongId = doc.id;
            song.songId = doc.data().songId;
            song.name = doc.data().name;
            song.artistId = doc.data().artistId;
            song.artistName = doc.data().artistName;
            song.albumId = doc.data().albumId;
            song.albumName = doc.data().albumName;
            song.albumPicture = doc.data().albumPicture;
            song.songUrl = doc.data().songUrl;

            playlistSongs.push(song);
          });

          resolve({ playlistSongs: playlistSongs });
        });
    });

    return promise;
  }

  getAlbum(albumId: string) {
    const promise = new Promise((resolve, reject) => {
      const db = firebase.firestore();

      db.collection('albums')
        .doc(albumId)
        .get()
        .then((doc) => {
          const album = new Album();

          album.albumId = doc.id;
          album.name = doc.data().name;
          album.picture = doc.data().picture;
          album.artistId = doc.data().artistId;
          album.artistName = doc.data().artistName;

          resolve({ album: album });
        });
    });

    return promise;
  }

  getAlbumSongs(albumId: string) {
    const promise = new Promise((resolve, reject) => {
      const db = firebase.firestore();

      db.collection('songs')
        .where('albumId', '==', albumId)
        .get()
        .then((songsSnapshot) => {
          const songs = [];

          songsSnapshot.forEach((doc) => {
            const song = new Song();

            song.songId = doc.id;
            song.name = doc.data().name;
            song.artistId = doc.data().artistId;
            song.artistName = doc.data().artistName;
            song.albumId = doc.data().albumId;
            song.albumName = doc.data().albumName;
            song.albumPicture = doc.data().albumPicture;
            song.songUrl = doc.data().songUrl;

            songs.push(song);
          });

          resolve({ songs: songs });
        });
    });

    return promise;
  }

  getArtist(artistId: string) {
    const promise = new Promise((resolve, reject) => {
      const db = firebase.firestore();

      db.collection('artists')
        .doc(artistId)
        .get()
        .then((doc) => {
          const artist = new Artist();

          artist.artistId = doc.id;
          artist.name = doc.data().name;
          artist.picture = doc.data().picture;

          resolve({ artist: artist });
        });
    });

    return promise;
  }

  getArtistAlbums(artistId: string) {
    const promise = new Promise((resolve, reject) => {
      const db = firebase.firestore();

      db.collection('albums')
        .where('artistId', '==', artistId)
        .get()
        .then((albumsSnapshot) => {
          const albums = [];

          albumsSnapshot.forEach((doc) => {
            const album = new Album();

            album.albumId = doc.id;
            album.name = doc.data().name;
            album.picture = doc.data().picture;
            album.artistId = doc.data().artistId;
            album.artistName = doc.data().artistName;

            albums.push(album);
          });

          resolve({ albums: albums });
        });
    });

    return promise;
  }

  getSongs() {
    const promise = new Promise((resolve, reject) => {
      const db = firebase.firestore();

      db.collection('songs')
        .get()
        .then((songsSnapshot) => {
          const songs = [];

          songsSnapshot.forEach((doc) => {
            const song = new Song();

            song.songId = doc.id;
            song.name = doc.data().name;
            song.artistId = doc.data().artistId;
            song.artistName = doc.data().artistName;
            song.albumId = doc.data().albumId;
            song.albumName = doc.data().albumName;
            song.albumPicture = doc.data().albumPicture;
            song.songUrl = doc.data().songUrl;

            songs.push(song);
          });

          resolve({ songs: songs });
        });
    });

    return promise;
  }

  getArtists() {
    const promise = new Promise((resolve, reject) => {
      const db = firebase.firestore();

      db.collection('artists')
        .get()
        .then((artistsSnapshot) => {
          const artists = [];

          artistsSnapshot.forEach((doc) => {
            const artist = new Artist();

            artist.artistId = doc.id;
            artist.name = doc.data().name;
            artist.picture = doc.data().picture;

            artists.push(artist);
          });

          resolve({ artists: artists });
        });
    });

    return promise;
  }

  getAlbums() {
    const promise = new Promise((resolve, reject) => {
      const db = firebase.firestore();

      db.collection('albums')
        .get()
        .then((albumsSnapshot) => {
          const albums = [];

          albumsSnapshot.forEach((doc) => {
            const album = new Album();

            album.albumId = doc.id;
            album.name = doc.data().name;
            album.picture = doc.data().picture;
            album.artistId = doc.data().artistId;
            album.artistName = doc.data().artistName;

            albums.push(album);
          });

          resolve({ albums: albums });
        });
    });

    return promise;
  }

  getIsFollowingPlaylist(userId: string, playlist: Playlist) {
    const promise = new Promise((resolve, reject) => {
      const db = firebase.firestore();

      db.collection('users')
        .doc(userId)
        .collection('playlistsFollowed')
        .get()
        .then((playlistsFollowedSnapshot) => {
          playlistsFollowedSnapshot.forEach((doc) => {
            if (doc.id === playlist.playlistId) {
              resolve({ isFollowing: true });
            }
          });

          resolve({ isFollowing: false });
        })
        .catch(function (error) {
          reject(error);
        });
    });

    return promise;
  }

  getIsFollowingAlbum(userId: string, album: Album) {
    const promise = new Promise((resolve, reject) => {
      const db = firebase.firestore();

      db.collection('users')
        .doc(userId)
        .collection('albumsFollowed')
        .get()
        .then((albumsFollowedSnapshot) => {
          albumsFollowedSnapshot.forEach((doc) => {
            if (doc.id === album.albumId) {
              resolve({ isFollowing: true });
            }
          });

          resolve({ isFollowing: false });
        })
        .catch(function (error) {
          reject(error);
        });
    });

    return promise;
  }

  getIsFollowingArtist(userId: string, artist: Artist) {
    const promise = new Promise((resolve, reject) => {
      const db = firebase.firestore();

      db.collection('users')
        .doc(userId)
        .collection('artistsFollowed')
        .get()
        .then((artistsFollowedSnapshot) => {
          artistsFollowedSnapshot.forEach((doc) => {
            if (doc.id === artist.artistId) {
              resolve({ isFollowing: true });
            }
          });

          resolve({ isFollowing: false });
        })
        .catch(function (error) {
          reject(error);
        });
    });

    return promise;
  }

  getSongLikeStatus(userId: string, song: Song) {
    // console.log('userid', userId, 'song', song);
    const promise = new Promise((resolve, reject) => {
      const db = firebase.firestore();

      db.collection('users')
        .doc(userId)
        .collection('songsFollowed')
        .get()
        .then((songsFollowedSnapshot) => {
          songsFollowedSnapshot.forEach((doc) => {
            if (doc.id === song.songId) {
              resolve({ isLiked: true });
            }
          });

          resolve({ isLiked: false });
        })
        .catch(function (error) {
          reject(error);
        });
    });

    return promise;
  }

  followPlaylist(userId: string, playlist: Playlist) {
    const promise = new Promise((resolve, reject) => {
      const db = firebase.firestore();

      db.collection('users')
        .doc(userId)
        .collection('playlistsFollowed')
        .doc(playlist.playlistId)
        .set(
          {
            name: playlist.name,
            picture: playlist.picture,
          },
          { merge: true }
        )
        .then(() => {
          resolve(true);
        })
        .catch(function (error) {
          reject(error);
        });
    });

    return promise;
  }

  unfollowPlaylist(userId: string, playlist: Playlist) {
    const promise = new Promise((resolve, reject) => {
      const db = firebase.firestore();

      db.collection('users')
        .doc(userId)
        .collection('playlistsFollowed')
        .doc(playlist.playlistId)
        .delete()
        .then(() => {
          resolve(true);
        })
        .catch(function (error) {
          reject(error);
        });
    });

    return promise;
  }

  getFavoritePlaylists(userId: string) {
    const promise = new Promise((resolve, reject) => {
      const db = firebase.firestore();

      db.collection('users')
        .doc(userId)
        .collection('playlistsFollowed')
        .get()
        .then((playlistsFollowedSnapshot) => {
          const favoritePlaylists = [];

          playlistsFollowedSnapshot.forEach((doc) => {
            const playlist = new Playlist();

            playlist.playlistId = doc.id;
            playlist.name = doc.data().name;
            playlist.picture = doc.data().picture;

            favoritePlaylists.push(playlist);
          });

          resolve({ favoritePlaylists: favoritePlaylists });
        })
        .catch(function (error) {
          reject(error);
        });
    });

    return promise;
  }

  getFavoriteSongs(userId: string) {
    console.log({userId});
    const promise = new Promise((resolve, reject) => {
      const db = firebase.firestore();

      db.collection('users')
        .doc(userId)
        .collection('songsFollowed')
        .get()
        .then((songsFollowedSnapshot) => {
          const favoriteSongs = [];

          songsFollowedSnapshot.forEach((doc) => {
            const song = new Song();

            song.songId = doc.id;
            song.name = doc.data().name;
            song.artistId = doc.data().artistId;
            song.artistName = doc.data().artistName;
            song.albumId = doc.data().albumId;
            song.albumName = doc.data().albumName;
            song.albumPicture = doc.data().albumPicture;
            song.songUrl = doc.data().songUrl;

            favoriteSongs.push(song);
          });

          resolve({ favoriteSongs: favoriteSongs });
        })
        .catch(function (error) {
          reject(error);
        });
    });

    return promise;
  }

  getFavoriteAlbums(userId: string) {
    const promise = new Promise((resolve, reject) => {
      const db = firebase.firestore();

      db.collection('users')
        .doc(userId)
        .collection('albumsFollowed')
        .get()
        .then((albumsFollowedSnapshot) => {
          const favoriteAlbums = [];

          albumsFollowedSnapshot.forEach((doc) => {
            const album = new Album();

            album.albumId = doc.id;
            album.name = doc.data().name;
            album.picture = doc.data().picture;
            album.artistId = doc.data().artistId;
            album.artistName = doc.data().artistName;

            favoriteAlbums.push(album);
          });

          resolve({ favoriteAlbums: favoriteAlbums });
        })
        .catch(function (error) {
          reject(error);
        });
    });

    return promise;
  }

  getFavoriteArtists(userId: string) {
    const promise = new Promise((resolve, reject) => {
      const db = firebase.firestore();

      db.collection('users')
        .doc(userId)
        .collection('artistsFollowed')
        .get()
        .then((artistsFollowedSnapshot) => {
          const favoriteArtists = [];

          artistsFollowedSnapshot.forEach((doc) => {
            const artist = new Artist();

            artist.artistId = doc.id;
            artist.name = doc.data().name;
            artist.picture = doc.data().picture;

            favoriteArtists.push(artist);
          });

          resolve({ favoriteArtists: favoriteArtists });
        })
        .catch(function (error) {
          reject(error);
        });
    });

    return promise;
  }

  getTodaysCTA() {
    const promise = new Promise((resolve, reject) => {
      const db = firebase.firestore();
      db.collection('cta')
        .get()
        
        .then((songsSnapshot:firebase.firestore.QuerySnapshot<firebase.firestore.DocumentData>) => {
          // console.log('todays quote ', songsSnapshot);
          var CTAArray = [];
          songsSnapshot.forEach((doc:firebase.firestore.QueryDocumentSnapshot<firebase.firestore.DocumentData>) => {
            // console.log(doc.data());
            const fbCTA = doc.data();
            const cta = new CTA();
            cta.image = fbCTA.image;
            cta.createdAt = fbCTA.created_at;
            cta.quote = fbCTA.quote;
            cta.subtitle = fbCTA.subtitle;
            cta.url = fbCTA.url;

            CTAArray.push(cta);

           });

          resolve(CTAArray);
        }).catch((e) => {
          console.log('some error in quotes');
          reject(e);
      })
    });
     return promise;
  }
    getTodaysQuote() {
    const promise = new Promise((resolve, reject) => {
      const db = firebase.firestore();
      db.collection('insperationQuotes')
        .get()
        
        .then((songsSnapshot:firebase.firestore.QuerySnapshot<firebase.firestore.DocumentData>) => {
          // console.log('todays quote ', songsSnapshot);
          var quotesArray = [];
          songsSnapshot.forEach((doc:firebase.firestore.QueryDocumentSnapshot<firebase.firestore.DocumentData>) => {
            // console.log(doc.data());
            const fbQuote = doc.data();
            const quotes = new Quotes();
            // quotes.image = fbQuote.image;
            quotes.createdAt = fbQuote.created_at;
            quotes.quote = fbQuote.quote;
            // quotes.subtitle = fbQuote.subtitle;
            // quotes.url = fbQuote.url;

            quotesArray.push(quotes);

           });

          resolve(quotesArray);
        }).catch((e) => {
          console.log('some error in quotes');
          reject(e);
      })
    });
     return promise;
  }

  likeSong(userId: string, song: Song) {
    const promise = new Promise((resolve, reject) => {
      const db = firebase.firestore();

      db.collection('users')
        .doc(userId)
        .collection('songsFollowed')
        .doc(song.songId)
        .set(
          {
            name: song.name,
            artistId: song.artistId,
            artistName: song.artistName,
            albumId: song.albumId,
            albumName: song.albumName,
            albumPicture: song.albumPicture,
            songUrl: song.songUrl,
          },
          { merge: true }
        )
        .then(() => {
          resolve(true);
        })
        .catch(function (error) {
          reject(error);
        });
    });

    return promise;
  }

  unlikeSong(userId: string, song: Song) {
    const promise = new Promise((resolve, reject) => {
      const db = firebase.firestore();

      db.collection('users')
        .doc(userId)
        .collection('songsFollowed')
        .doc(song.songId)
        .delete()
        .then(() => {
          resolve(true);
        })
        .catch(function (error) {
          reject(error);
        });
    });

    return promise;
  }

  followAlbum(userId: string, album: Album) {
    const promise = new Promise((resolve, reject) => {
      const db = firebase.firestore();

      db.collection('users')
        .doc(userId)
        .collection('albumsFollowed')
        .doc(album.albumId)
        .set(
          {
            name: album.name,
            picture: album.picture,
            artistId: album.artistId,
            artistName: album.artistName,
          },
          { merge: true }
        )
        .then(() => {
          resolve(true);
        })
        .catch(function (error) {
          reject(error);
        });
    });

    return promise;
  }

  unfollowAlbum(userId: string, album: Album) {
    const promise = new Promise((resolve, reject) => {
      const db = firebase.firestore();

      db.collection('users')
        .doc(userId)
        .collection('albumsFollowed')
        .doc(album.albumId)
        .delete()
        .then(() => {
          resolve(true);
        })
        .catch(function (error) {
          reject(error);
        });
    });

    return promise;
  }

  followArtist(userId: string, artist: Artist) {
    const promise = new Promise((resolve, reject) => {
      const db = firebase.firestore();

      db.collection('users')
        .doc(userId)
        .collection('artistsFollowed')
        .doc(artist.artistId)
        .set(
          {
            name: artist.name,
            picture: artist.picture,
          },
          { merge: true }
        )
        .then(() => {
          resolve(true);
        })
        .catch(function (error) {
          reject(error);
        });
    });

    return promise;
  }

  unfollowArtist(userId: string, artist: Artist) {
    const promise = new Promise((resolve, reject) => {
      const db = firebase.firestore();

      db.collection('users')
        .doc(userId)
        .collection('artistsFollowed')
        .doc(artist.artistId)
        .delete()
        .then(() => {
          resolve(true);
        })
        .catch(function (error) {
          reject(error);
        });
    });

    return promise;
  }

  getSong(songId: string) {
    const promise = new Promise((resolve, reject) => {
      const db = firebase.firestore();

      db.collection('songs')
        .doc(songId)
        .get()
        .then((doc) => {
          const song = new Song();

          song.songId = doc.id;
          song.name = doc.data().name;
          song.artistId = doc.data().artistId;
          song.artistName = doc.data().artistName;
          song.albumId = doc.data().albumId;
          song.albumName = doc.data().albumName;
          song.albumPicture = doc.data().albumPicture;
          song.songUrl = doc.data().songUrl;

          resolve({ song: song });
        });
    });

    return promise;
  }

  getPlaylistGroups() {
    const promise = new Promise((resolve, reject) => {
      const db = firebase.firestore();

      db.collection('playlistGroups')
        .orderBy('addedAt', 'asc')
        .get()
        .then((playlistGroupsSnapshot) => {
          const playlistGroups = [];

          playlistGroupsSnapshot.forEach((doc) => {
            const playlistGroup = new PlaylistGroup();

            playlistGroup.playlistGroupId = doc.id;
            playlistGroup.name = doc.data().name;

            playlistGroups.push(playlistGroup);
          });

          resolve({ playlistGroups: playlistGroups });
        });
    });

    return promise;
  }

  getPlaylistGroupPlaylists(playlistGroup: PlaylistGroup) {
    const promise = new Promise((resolve, reject) => {
      const db = firebase.firestore();

      db.collection('playlistGroups')
        .doc(playlistGroup.playlistGroupId)
        .collection('playlists')
        .orderBy('addedAt', 'asc')
        .get()
        .then((playlistGroupPlaylistsSnapshot) => {
          const playlistGroupPlaylists = [];

          playlistGroupPlaylistsSnapshot.forEach((doc) => {
            const playlist = new Playlist();

            playlist.playlistId = doc.data().playlistId;
            playlist.name = doc.data().name;
            playlist.picture = doc.data().picture;

            playlistGroupPlaylists.push(playlist);
          });

          resolve({ playlistGroupPlaylists: playlistGroupPlaylists });
        });
    });

    return promise;
  }

  getGenres() {
    const promise = new Promise((resolve, reject) => {
      const db = firebase.firestore();

      db.collection('genres')
        .get()
        .then((genresSnapshot) => {
          const genres = [];

          genresSnapshot.forEach((doc) => {
            const genre = new Genre(doc.data().name, doc.data().picture);
            genre.genreId = doc.id;

            genres.push(genre);
            // console.log('genre', genres);
          });

          resolve({ genres: genres });
        });
    });

    return promise;
  }

  getGenreSongs(genre: Genre) {
    const promise = new Promise((resolve, reject) => {
      const db = firebase.firestore();

      db.collection('genres')
        .doc(genre.genreId)
        .collection('songs')
        .get()
        .then((genreSongsSnapshot) => {
          const genreSongs = [];

          genreSongsSnapshot.forEach((doc) => {
            const song = new Song();

            song.genreSongId = doc.id;
            song.songId = doc.data().songId;
            song.name = doc.data().name;
            song.artistId = doc.data().artistId;
            song.artistName = doc.data().artistName;
            song.albumId = doc.data().albumId;
            song.albumName = doc.data().albumName;
            song.albumPicture = doc.data().albumPicture;
            song.songUrl = doc.data().songUrl;

            genreSongs.push(song);
          });

          resolve({ genreSongs: genreSongs });
        });
    });

    return promise;
  }

  updateName(name) {
    const promise = new Promise((resolve) => {
      const db = firebase.firestore();
      db.collection('users')
        .doc(this.uid)
        .set(
          {
            name: name,
          },
          { merge: true }
        )
        .then(() => {
          resolve(true);
        })
        .catch(() => {
          resolve(false);
        });
    });

    return promise;
  }

  getSongDetail(userId: string, song: Song) {
    // return;
    const promise = new Promise((resolve, reject) => {
      const db = firebase.firestore();

      db.collection('songDetail')
        .where('userId', '==', userId)
        .onSnapshot(
          (val) => {
            if (val.docs.length == 0) {
              // console.log('songs val.docs.length');
              resolve(false);
            } else {
              val.forEach((snapval: any) => {
                // console.log('val', snapval.id, snapval.data());
                // check if songId exist
                var songId = snapval.data().songId;
                var songDate = snapval.data().date;
                var sameDate =
                  new Date(songDate).getDate() == new Date().getDate();
                // console.log({ songDate, sameDate })
                if (songId == song.songId && sameDate) {
                  // console.log('songs exist');
                  resolve(snapval.id);
                } else {
                  // console.log('song not exist else');
                  resolve(false);
                }
              });
            }

            // resolve(val);
          },
          (e) => console.log('e', e)
        );
    });

    return promise;
  }
  setSongPlayingDuration(stop?: boolean) {
    var initailDuration = 0;
    var interval = setInterval(() => {
      initailDuration++;
      // console.log({ initailDuration });
    }, 1000);
    // console.log({ initailDuration });

    if (initailDuration > 5) {
      // initailDuration = 0;
      clearInterval(interval);
      console.log({ stop, interval });
    }
  }

  songDetail(userId: string, song: Song) {
    // console.log('songs detail', userId, song);
    // return;
    this.getSongDetail(userId, song).then((isSong: any) => {
      if (isSong) {
        // console.log('if cahala')

        const db = firebase.firestore();

        let ref = db.collection('songDetail').doc(isSong);
        db.runTransaction((t) => {
          return t.get(ref).then((doc) => {
            let newPop = doc.data().numberOfPlayed + 1;
            t.update(ref, { numberOfPlayed: newPop });
            console.log('doc', doc.data());
          });
        });
      } else {
        const db = firebase.firestore();

        db.collection('songDetail')
          .add({
            name: song.name,
            date: firebase.firestore.FieldValue.serverTimestamp(),
            userId: userId,
            // moodName: song.genreSongName,
            // moodId: song.genreSongId,
            totalTime: song['duration'],
            songId: song.songId,
            numberOfPlayed: 1,
          })
          .then(() => { })
          .catch(function (error) { });
      }
    });
  }
}
